var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"w-sidenav"},[_c('div',{staticClass:"b-sidenav b-sidenav--profile"},[_c('ProfileMenu',{attrs:{"tab":_vm.tab}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }